import { useMutation } from "@apollo/client"
import { ROUND_RESET } from "../queries/roundReset"

interface RoundResetInput {
  tournamentId: number
  roundId: number
  resetType: number
}

export const useRoundReset = () => {
  const [resetRound, { loading, error }] = useMutation(ROUND_RESET)

  const roundReset = async (input: RoundResetInput) => {
    try {
      const { data } = await resetRound({
        variables: {
          RoundResetInput: input,
        },
      })
      return data?.RoundReset
    } catch (err) {
      console.error("Error resetting round:", err)
      throw err
    }
  }

  return {
    roundReset,
    loading,
    error,
  }
}
